import React from "react";
import styles from "./VideoContainer.module.scss";
import ConsentAwareEmbed from "@/components/ConsentAwareEmbed/ConsentAwareEmbed";

interface VideoContainerProps {
  videoSource: string; // URL відео
  title: string; // Заголовок відео
}

const VideoContainer: React.FC<VideoContainerProps> = ({
  videoSource,
  title,
}) => {
  return (
    <div className="container">
      <div className={styles.videoWrapper}>
        <ConsentAwareEmbed type="youtube">
          <iframe
            src={videoSource} // джерело відео (URL YouTube)
            title={title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className={styles.video}
          ></iframe>
        </ConsentAwareEmbed>
      </div>
    </div>
  );
};

export default VideoContainer;
